import { useLazyQuery, useQuery } from "@apollo/client";
import { Grid, useMediaQuery } from "@material-ui/core";
import SearchBox from "components/SearchBox";
import Table from "components/Table";
import { DATE_FORMAT_PRINT } from "config/constants";
import { theme } from "config/theme";
import useText from "constants/text";
import { useParcelListStyles } from "domains/Task/components/Job/styles";
import { ALL_HUBS, GET_HUBS_BY_CITY } from "domains/Task/graphql/queries";
import HTTP_STATUS_CODES, { useReceiversColumns } from "domains/Task/types/Column";
import { Hub, Job, JobType, Receiver } from "generated/graphql";
import { CalendarIcon, ClockIcon, NewParcelIcon } from "icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "styled-components/macro";
import { Button } from "ui/Button";
import { makeSearch } from "utils";
import { useReceiverListStyles, useReceiverStyles } from "./style";

export interface ReceiversProps {
  receivers: Receiver[];
  job: Job;
  onSelectedJob?: (receiver: Receiver) => void;
  onAllRowChecked?: (ids: string[]) => void;
  showForm: any;
  handleHubSelect?(data: Hub): void;
  handleGetRowsChecked?(data: string[]): void;
  handleGetReceiverHub?(data: Hub, rowId: string): void;
  inputValueRelayPoint?: any;
  setInputValueRelayPoint?(value: any, receiverId: string): void;
  onSelected?: (receiversId: string[]) => void;
}

export function ReceiverList({
  receivers,
  job,
  onSelectedJob,
  onAllRowChecked,
  showForm,
  handleHubSelect,
  handleGetRowsChecked,
  handleGetReceiverHub,
  inputValueRelayPoint,
  onSelected,
}: ReceiversProps) {
  const styles = useReceiverListStyles();
  const classes = useReceiverStyles();
  const parcelStyle = useParcelListStyles();
  const [search, setValue] = React.useState<string>("");
  const { data: relayData } = useQuery(ALL_HUBS);
  const [relayPointCity, setRelayPointCity] = useState([]);
  const { text } = useText();
  const [getAllHubsByCity, { loading, data: hubsByCity }] = useLazyQuery(GET_HUBS_BY_CITY);
  const [relays, setRelays] = React.useState([]);
  const [cityValue, setCityValue] = React.useState<String>(null);
  const [inputRelayPoint, setInputRelayPoint] = useState<String>(null);

  const [selectId, setSelectId] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  React.useEffect(() => {
    if (cityValue) {
      getAllHubsByCity({
        variables: {
          queries: {
            city: cityValue,
          },
        },
      });
    }
  }, [cityValue]);

  React.useEffect(() => {
    if (hubsByCity) {
      const getHubs = hubsByCity?.getAllHubsByCity;
      if (getHubs?.code === HTTP_STATUS_CODES.OK) {
        setRelays(getHubs?.data);
      }
    }
  }, [hubsByCity]);
  const onSearch = (event: any) => {
    event.preventDefault();
    event.persist();
    setValue(event.target.value);
  };

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const handleSelected = React.useCallback((row?: string[]) => {
    setSelectId(row);
  }, []);
  useEffect(() => {
    if (relayData) {
      const hubs = relayData?.allHubs;

      if (hubs?.code === HTTP_STATUS_CODES.OK) {
        const relayPointCity = hubs?.data?.map((hub: any) => hub?.location?.city);
        const filterCity = relayPointCity.filter((city: string) => city);
        setRelayPointCity(filterCity);
      }
    }
  }, [relayData]);
  const handleOnInputRelaypointChange = (event: any, name: string) => {
    handleGetReceiverHub(event, name)
    setInputRelayPoint(name);
  };
  const handleSelect = (event: any, name: string) => {
    setCityValue(name);
  };
  const ReceiversColumns = useReceiversColumns(text, {
    handleHubSelect,
    selectId,
    relayPointCity,
    cityValue,
    handleSelect,
    loading,
    relays,
    inputValueRelayPoint,
    handleOnInputRelaypointChange,
  } as any);

  const lists: any[] = React.useMemo(() => (search ? makeSearch(receivers, search) : receivers), [search, receivers]);
  return (
    <>
      <Grid container className={styles.root}>
        <Grid xs={12} item className={styles.topListReceiver}>
          <Grid item xs={6} className={styles.iconAdress}>
            <Grid className={styles.caisse}>
              <Grid
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                <NewParcelIcon />
              </Grid>
            </Grid>
            <Grid className={styles.nameContent}>
             <div className={styles.type}>
            {job.job_type.replace(/_/g, " ") === JobType.FromStock && text.all.from_stock_label}              
              {job.job_type.replace(/_/g, " ") === JobType.Dropoff && text.all.drop_off_label}
              {job.job_type.replace(/_/g, " ") === JobType.Pickup && text.all.pickup_label}
              </div> 
              <div className={styles.name}>{`${
                isSmallScreen ? job?.job_address?.address.substring(0, 20) : job?.job_address?.address.substring(0, 35)
              }...`}</div>
            </Grid>
          </Grid>
          <Grid item xs={4} className={styles.detail}>
            <div className={styles.bloc}>
              <div className={styles.icon}>
                <CalendarIcon />
              </div>
              <div className={styles.number}>{moment(new Date()).format(DATE_FORMAT_PRINT)}</div>
            </div>
            <div className={styles.bloc}>
              <div className={styles.icon}>
                <ClockIcon />
              </div>
              <div className={styles.time}>{moment(new Date()).format("LT")}</div>
            </div>
          </Grid>
          <Grid item xs={6} className={styles.fixedTop}>
            <SearchBox className={styles.search} value={search} onChange={onSearch} />
            <Button className={styles.button} color="primary" variant="contained" onClick={() => showForm(true)}>
              {text.all.add_new_receiver}
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12} className={parcelStyle.table}>
          <Table
            rowsIdentifier="_id"
            columns={ReceiversColumns}
            data={lists}
            hasSelection
            onRowCheckedRow={handleSelected}
            onRowChecked={onSelected}
            onAllRowChecked={onAllRowChecked}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            handleGetRowsChecked={handleGetRowsChecked}
          />
        </Grid>
      </Grid>
    </>
  );
}
